import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import AOS from "aos";
import { environment } from "src/environments/environment";
@Component({
  selector: "app-onp18link",
  templateUrl: "./onp18link.component.html",
  styleUrls: ["./onp18link.component.scss"]
})
export class Onp18linkComponent implements OnInit { 
myLinksS3URL = environment.myLinksS3URL;
  userId!: string;
  onPassiveBaseUrl: string = environment.onPassiveBaseUrl;
  constructor(private aRoute: ActivatedRoute) {
    this.aRoute.queryParams.subscribe((params) => {
      this.userId = params["onpassive"];
    });
  }

  ngOnInit(): void {
    AOS.init();
  }
}
